module.exports = __webpack_public_path__ + "c20ca823560c4209d6b0c0b409d2cd99.svg";